<template>
  <div>
    <a-tooltip placement="top" v-if="!disableTooltip">
      <template #title>
        <span>{{ state ? tooltip : tooltipActive }}</span>
      </template>
      <v-btn
        x-small
        class="btn-control"
        :rounded="rounded"
        :fab="fab"
        dark
        :height="height"
        :width="width"
        :color="state ? color : colorActive"
        @click="click"
      >
        <v-icon :color="state ? '#20409C' : 'white'" dark>{{ state ? icon : iconActive }}</v-icon>
      </v-btn>
    </a-tooltip>

    <div v-else>
      <v-btn
        x-small
        class="btn-control"
        :rounded="rounded"
        :fab="fab"
        dark
        :height="height"
        :color="state ? color : colorActive"
        @click="click"
      >
        <v-icon dark>{{ state ? icon : iconActive }}</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },

    // TODO ใช้ในการแสดงข้อความ Tooltip เมื่อไม่ Active
    tooltip: {
      type: String,
      default: 'undefine'
    },

    // TODO ใช้ในการแสดงข้อความ Tooltip เมื่อ Active
    tooltipActive: {
      type: String,
      default: 'undefine'
    },

    // TODO ใช้ในการแสดง Icon เมื่อยังไม่ Active
    icon: {
      type: String,
      default: 'mdi-alert-outline'
    },

    // TODO ใช้ในการแสดง Icon เมื่อ Active
    iconActive: {
      type: String,
      default: 'mdi-alert'
    },

    // TODO ใช้ในการเปิดปิด Tooltip
    disableTooltip: {
      type: Boolean,
      default: false
    },

    // TODO ใช้ในการ reverse Value
    reverse: {
      type: Boolean,
      default: false
    },

    // TODO ใช้ในการ กำหนดสีเมื่อไม่ Active
    color: {
      type: String,
      default: 'white'
    },

    // TODO ใช้ในการ กำหนดสีเมื่อ Active
    colorActive: {
      type: String,
      default: 'error'
    },

    // NOTE Custom Element vuetify btn
    fab: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '32'
    },
    height: {
      type: String,
      default: '32'
    }
    // NOTE Custom Element vuetify btn
  },
  computed: {
    state: {
      get () {
        return this.reverse ? !this.value : this.value
      },
      set (val) {
        this.$emit('input', this.reverse ? !val : val)
      }
    }
  },

  methods: {
    click () {
      this.state = !this.state
      this.$emit('click', this.state)
    }
  }
}
</script>

<style lang="scss" scoped></style>
